import { BroadcastAudioCodec, BroadcastEncodingOptions, BroadcastVideoCodec } from '../types/broadcasting';
import { Action } from '../types/types';
import type { DebugState } from '../types/debug';

export const initialDebugState: DebugState = {
	debugEnabled: false,
	debugOverlaysEnabled: true,
	debugEchoCancellationEnabled: true,
	debugSocketCanDispatch: true,
	debugOpentok: false,
	debugKillServer: false,
	debugDisconnectProducer: false,
	debugLogIsoAlerts: false,
	useDebugEncodingOptions: false,
	debugAVUI: false,
	debugEncodingOptions: {
		width: 1920,
		height: 1080,
		depth: 24,
		framerate: 30,
		audioCodec: BroadcastAudioCodec.OPUS,
		audioBitrate: 128,
		audioFrequency: 44100,
		videoCodec: BroadcastVideoCodec.H264_MAIN,
		videoBitrate: 6000,
		keyFrameInterval: 1,
	},
};

const actions: Map<string, Function> = new Map([
	['DEBUG_TOGGLE_DEBUG', (state: DebugState, action: Action): any => ({ ...state, debugEnabled: action.payload })],
	['DEBUG_TOGGLE_OVERLAYS', (state: DebugState, action: Action): any => ({ ...state, debugOverlaysEnabled: action.payload })],
	['DEBUG_TOGGLE_ECHO_CANCELLATION', (state: DebugState, action: Action): any => ({ ...state, debugEchoCancellationEnabled: action.payload })],
	['DEBUG_TOGGLE_SOCKET_DISPATCH', (state: DebugState, action: Action): any => ({ ...state, debugSocketCanDispatch: action.payload })],
	['DEBUG_OPENTOK_DISPATCH', (state: DebugState, action: Action): any => ({ ...state, debugOpentok: action.payload })],
	['DEBUG_TOGGLE_KILL_SERVER', (state: DebugState, action: Action): any => ({ ...state, debugKillServer: action.payload })],
	['DEBUG_TOGGLE_LOG_ISO_ALERTS', (state: DebugState, action: Action): any => ({ ...state, debugLogIsoAlerts: action.payload })],
	['USE_DEBUG_ENCODING_OPTIONS', (state: DebugState, action: Action): any => ({ ...state, useDebugEncodingOptions: action.payload })],
	['DEBUG_ENCODING_OPTIONS', (state: DebugState, action: Action): any => ({ ...state, debugEncodingOptions: action.payload })],
	['DEBUG_AV_UI', (state: DebugState, action: Action): any => ({ ...state, debugAVUI: action.payload })],
]);

// eslint-disable-next-line default-param-last
export function DebugReducer(state: DebugState = initialDebugState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
